<template>
  <v-text-field
    class="email-input"
    :label="placeholder ? null : label"
    :readonly="readonly"
    :rules="rules"
    :disabled="disabled"
    autocomplete="username"
    :filled="filled"
    required
    outlined
    v-model="email"
    :append-outer-icon="icon"
    :background-color="backgroundColor"
    :errorMessages="errorMessages"
    :hide-details="hideDetails"
    :placeholder="placeholder"
    :dense="dense"
    :append-icon="appendIcon"
    @click:append="clickAppendix"
    :validate-on-blur="validateOnBlur"/>
</template>

<script>
export default {
  name: 'fin-email-input',
  props: {
    value: {
      type: String
    },
    readonly: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String,
      default: 'Deine E-Mail-Adresse'
    },
    filled: {
      type: Boolean
    },
    icon: {
      type: String
    },
    backgroundColor: {
      type: String, default: ''
    },
    errorMessages: {
      type: String
    },
    /** live validation or validate on blur event */
    validateOnBlur: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    appendIcon: {
      type: String
    },
    clickAppend: {
      type: Function
    }
  },
  data() {
    return {
      rules: [
        v => !!v || 'Gebe bitte deine E-Mail-Adresse ein.',
        v => /.+@.+\..+/.test(v) || 'Die eingegebene E-Mail-Adresse ist nicht gültig.'
      ],
      email: this.value
    }
  },
  methods: {
    clickAppendix() {
      this.$emit("click:append")
      if (this.clickAppend !== undefined) {
        this.clickAppend()
      }
    }
  },
  watch: {
    value(val) {
      this.email = val.trim()
    },
    email(val) {
      this.$emit('input', val.trim())
    }
  }
}
</script>

<style scoped>

.email-input ::v-deep .v-messages {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 19px;
  letter-spacing: normal;
  color: #000 !important;
}

.email-input ::v-deep .error--text .v-messages__message {
  padding-left: 20px;
  line-height: 19px;
  background-image: url("./../../../assets/error/warning.png");
}

</style>
